<script>
  import { Button } from "$lib/components/ui/button";
  import * as AlertDialog from "$lib/components/ui/alert-dialog/index.js";
  import { buttonVariants } from "$lib/components/ui/button/index.js";
  import { router } from "@inertiajs/svelte";
  import { inertia } from "@inertiajs/svelte";
  import { Link } from "@inertiajs/svelte";
  import Toast, { toast } from "$lib/components/ui/toast";
  import SunIcon from "@lucide/svelte/icons/sun";
  import MoonIcon from "@lucide/svelte/icons/moon";

  import { toggleMode } from "mode-watcher";

  // 如果有 props，从 Rails 传过来
  export let props = {};
  export let auth;
  // 示例：显示欢迎信息
  $: username = auth?.user?.name || "游客";
  function test() {
    console.log("按钮被点击了");
    router.visit("/about"); // 加日志 + 选项
  }
</script>

<div class="min-h-screen flex items-center justify-center p-4">
  <div class="text-center">
    <h1 class="text-2xl font-bold text-violet-600 mb-4">Welcome to Lazavel!</h1>
    <p class="text-normal text-gray-700">这是一个使用测试页面。</p>

    <Button onclick={test}>测试</Button>
    <button onclick={test}>原生按钮测试</button>

    <Link href="/about" class="text-blue-500 underline">使用Link链接测试</Link>

    <a
      href="/about"
      use:inertia
      class="inline-block rounded-sm border border-transparent px-5 py-1.5 text-sm leading-normal text-[#1b1b18] hover:border-[#19140035] dark:text-[#EDEDEC] dark:hover:border-[#3E3E3A]"
    >
      使用链接测试
    </a>

    <Button
      variant="outline"
      onclick={async () => {
        // 语义化：开启加载
        toast.loading("正在保存到服务器...");

        // 模拟 Inertia 或 Fetch 请求
        setTimeout(() => {
          const isSuccess = false; // 模拟结果

          if (isSuccess) {
            // 语义化：显示成功
            toast.success("保存成功！");
          } else {
            // 语义化：显示错误
            toast.error("网络连接失败，请重试");
          }
        }, 2000);
      }}
    >
      Show Toast
    </Button>

    <Button onclick={toggleMode} variant="outline" size="icon">
      <SunIcon
        class="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 !transition-all dark:scale-0 dark:-rotate-90"
      />
      <MoonIcon
        class="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 !transition-all dark:scale-100 dark:rotate-0"
      />
      <span class="sr-only">Toggle theme</span>
    </Button>

    <div class="space-x-4">
  <button onclick={() => toast.success("操作成功")}>点我成功</button>
  <button onclick={() => toast.error("发生故障")}>点我报错</button>
  <button onclick={() => toast.info("这是一些信息")}>点我信息</button>
  <button onclick={() => toast.loading("正在加载...")}>点我加载</button>
  <button onclick={() => toast.hide()}>点我隐藏</button>
  </div>

    <AlertDialog.Root>
      <AlertDialog.Trigger class={buttonVariants({ variant: "outline" })}>
        Show Dialog
      </AlertDialog.Trigger>
      <AlertDialog.Content>
        <AlertDialog.Header>
          <AlertDialog.Title>Are you absolutely sure?</AlertDialog.Title>
          <AlertDialog.Description>
            This action cannot be undone. This will permanently delete your
            account and remove your data from our servers.
          </AlertDialog.Description>
        </AlertDialog.Header>
        <AlertDialog.Footer>
          <AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
          <AlertDialog.Action>Continue</AlertDialog.Action>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog.Root>

    {#if props.message}
      <p class="mt-4 text-green-600">{props.message}</p>
    {/if}
  </div>
</div>
